<template>
  <div class="hello">
     <div class="ps-page--my-account">
        <div class="ps-breadcrumb">
            <div class="container">
                <ul class="breadcrumb">
                    <li v-if="isEnglish()==true"><a href="/#/private">Home</a></li>
                    <li v-if="isEnglish()==false"><a href="/#/private">Acceuil</a></li>
                    <li v-if="isEnglish()==true">Forgot password</li>
                    <li v-if="isEnglish()==false">Mot de passe oublié</li>
                </ul>
            </div>
        </div>
        <div class="ps-my-account">
            <div class="container">
                <form class="ps-form--account ps-tab-root" @submit.prevent="forgotpassword">

                        <div class="ps-tab active">


                      <div v-if="sent" class="spinner-border" role="status">
                         <span class="visually-hidden">Loading...</span>
                      </div>
                        <div  v-if="failed" class="alert alert-danger" role="alert">
                        {{ errorm }}
                      </div>
                            <div class="ps-form__content">
                                <h5 v-if="isEnglish()==true">Forgot password ?</h5>
                                <h5 v-if="isEnglish()==false">Mot de passe oublié ?</h5>
                                <div class="form-group">
                                    <input class="form-control"
                                    type="text"
                                    placeholder="Your email address"
                                    required
                                    v-model="user.email"
                                    >
                                </div>

                                <div class="form-group submtit">
                                    <button v-if="isEnglish()==true" @click="forgotpassword" :disabled="clicked" class="ps-btn ps-btn--fullwidth">Submit</button>
                                    <button v-if="isEnglish()==false" @click="forgotpassword" :disabled="clicked" class="ps-btn ps-btn--fullwidth">Envoyer</button>

                                </div>
                            </div>
                             <div class="ps-form__footer">

                                <ul class="ps-list--social">

                                </ul>
                            </div>

                        </div>

                </form>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import DataService from "@/services/DataService";
export default {
  name: 'ForgotPassword',
  data () {
    return {
      clicked: false,
      sent: false,
      failed : false,
      errorm : "",
       user: {
        email: "",

      }
    }
  },
      methods: {

    forgotpassword() {

      this.failed = false;
      this.sent = false;
      const lang = navigator.language.substring(0, 2);
      var data = {
        email: this.user.email,
        lang:lang
      };

      //console.log(data);
      this.clicked = true;
      this.sent = true;
      DataService.password_reset_post(data)
        .then(response => {

          //console.log(response.data);
          this.sent = false;
          this.user= { email: "" };

          //alert(" A verification code has been sent to you mail.");
          this.$router.push('/reset-password');

        })
        .catch(e => {
          console.log(e);
          this.sent = false;
          this.errorm = this.$parent.translate_error_message(e.response.data.errors,"errors");
          this.failed = true;
          this.user= { email: "" };
          console.log(e.response.data.errors);
        });

       setTimeout(function(){
        this.clicked = false;
       }.bind(this),1000);
    },

    isEnglish(){

            let lang = localStorage.getItem('lang');
            if(lang=='en'){

            return true;

            }else if(lang=='fr'){

            return false;

            }else{

            return true;

            }

    },



},
  created(){
         this.$emit("giveway",false);

         this.$emit("headerAndFooter",false);
     },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ps-my-account {
    min-height: calc(100vh - 61px);
  }
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue